import { gql, useQuery } from '@apollo/client';

const ADVISORY_TEAM_FOR_WIDGET = gql`
  query AdvisoryTeamForWidget {
    currentUser {
      id
      advisory_team_members {
        id
        role
        status
        name
        firm
      }
    }
  }
`;

/**
 * Returns the advisory_team_member matching the given partner_category
 * (e.g. 'cbv', 'lawyer', 'accountant'), or null if the role is not filled.
 *
 * Reads from Apollo's normalized cache via cache-first fetch policy. Once any
 * container has populated `currentUser` with `advisory_team_members`, this
 * hook is a zero-network read for subsequent renders. Apollo's normalization
 * keys on `__typename:id`, so as long as fields are a subset, cache merges
 * correctly across queries.
 *
 * Used by ReadyToConnectWidget to keep the widget self-contained — consumers
 * no longer need to thread teamMemberName/Status/Firm scalar props.
 */
export function useAdvisoryTeamMember(partnerCategory) {
  const { data } = useQuery(ADVISORY_TEAM_FOR_WIDGET, {
    fetchPolicy: 'cache-first',
  });
  if (!partnerCategory) return null;
  const members = data?.currentUser?.advisory_team_members || [];
  return members.find((m) => m.role === partnerCategory) || null;
}

export default useAdvisoryTeamMember;
